export default {
    methods: {
        goToCarouselPage({ trackRef, page, pagesCount, setPage, lockSync }) {
            const totalPages = pagesCount
            const targetPage = ((page % totalPages) + totalPages) % totalPages
            setPage(targetPage)
            lockSync()
            const track = this.$refs[trackRef]
            if (!track || !track.firstElementChild) return
            const step = track.firstElementChild.getBoundingClientRect().width + 12
            track.scrollTo({ left: targetPage * step * 3, behavior: 'smooth' })
        },
        lockCarouselScrollSync({ syncEnabledKey, unlockTimerKey, trackRef }) {
            this[syncEnabledKey] = false
            clearTimeout(this[unlockTimerKey])
            const track = this.$refs[trackRef]
            const unlock = () => {
                this[syncEnabledKey] = true
            }
            if (track && 'onscrollend' in track) {
                track.addEventListener('scrollend', unlock, { once: true })
            }
            this[unlockTimerKey] = setTimeout(unlock, 500)
        },
        onCarouselScroll({ trackRef, syncEnabledKey, rafKey, pagesCount, currentPageKey }) {
            if (!this[syncEnabledKey]) {
                return
            }
            if (this[rafKey]) {
                cancelAnimationFrame(this[rafKey])
            }
            this[rafKey] = requestAnimationFrame(() => {
                const track = this.$refs[trackRef]
                if (!track || !track.firstElementChild) return
                const step = track.firstElementChild.getBoundingClientRect().width + 12
                const nextPage = Math.round(track.scrollLeft / (step * 3))
                const clampedPage = Math.max(0, Math.min(pagesCount - 1, nextPage))
                if (clampedPage !== this[currentPageKey]) {
                    this[currentPageKey] = clampedPage
                }
            })
        },
    },
}
